import { Download } from "@mui/icons-material";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import exportFromJSON from "export-from-json";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React from "react";
import DateFormatter from "./dateFormatter";
import { HttpRequest } from "../HttpRequest";
import { SuccessAlert } from '../common/snackbar/success';
import { ErrorAlert } from '../common/snackbar/error';
import { useState } from "react";


const ExportData = ({ data, tableColumn, title, otherData }) => {
   const [successShow, setSuccessShow] = useState({ state: false, message: "" });
   const [errorShow, setErrorShow] = useState({ state: false, message: "" });
    const timestamp = new Date();
    const fileName = `${title}_${DateFormatter(timestamp)}`;

    const ExportXLXS = () => {
        const excelFileName = fileName;
        const exportType = "xls";
        exportFromJSON({ data, excelFileName, exportType });
    };

    const ExportCSV = () => {
        const csvFileName = fileName;
        const exportType = "csv";
        exportFromJSON({ data, csvFileName, exportType });
    };

    const exportPDF = () => {
        const doc = new jsPDF();
        const tableRows = [];

        data.forEach(item => {
            const itemData = tableColumn.map(col => item[col.field]);
            tableRows.push(itemData);
        });

        doc.autoTable({
            head: [tableColumn.map(col => col.headerName)],
            body: tableRows,
        });

        doc.text(title, 16, 10);

        const pdfFileName = `${fileName}.pdf`;
        doc.save(pdfFileName);
    };

    const sendToEmail = () => {
        try {
            HttpRequest({
                method: 'GET',
                url: `/alltransactionexportascsv?exportData=exportData&startDate=${otherData?.from}&endDate=${otherData?.to}&transactionType=${''}&reportType=${otherData?.reportType}&searchValue=${otherData?.searchValue}&cashier=`,
                token: localStorage.getItem("X-Authorization"),
            }).then((data)=>{
                if(data?.status === 200){
                setSuccessShow({state:true , message:data?.response?.message})
                }else{
                setErrorShow({state:true , message:data?.response?.message})
                }
            })
        } catch (error) {
            setErrorShow({state:true , message:error?.message})
        }
    }

    return (
        <Box sx={{ display: 'flex',mt:'10px' }}>
            <Box>
                <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
                <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
            </Box>
            <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                    <React.Fragment>
                        <Button variant='contained' sx={{ margin: '0px 0.5px 3.5px 4px', backgroundColor: '#032541', textTransform: 'capitalize', textWrap: 'nowrap', "&:hover": { backgroundColor: '#032541' } }} {...bindTrigger(popupState)} startIcon={<Download />}>
                            Export
                        </Button>
                        <Menu {...bindMenu(popupState)}>
                            <MenuItem onClick={() => { ExportCSV(); popupState.close(); }}>CSV</MenuItem>
                            <MenuItem onClick={() => { ExportXLXS(); popupState.close(); }}>Excel</MenuItem>
                            <MenuItem onClick={() => { exportPDF(); popupState.close() }}>PDF</MenuItem>
                            <MenuItem onClick={() => { sendToEmail(); popupState.close() }}>Send To Email</MenuItem>
                        </Menu>
                    </React.Fragment>
                )}
            </PopupState>
        </Box>
    );
};

export default ExportData;
